import React, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Checkbox } from 'components/ui';
import useCheckPermissions from 'hooks/auth/useCheckPermission';
import { EMAIL_TYPE_IDS } from 'constants/mail';

const ToggleDisableTracking = ({ categoryName, emailTypeId }) => {
  const { control, setValue, watch } = useFormContext();
  const { userCheckPermission } = useCheckPermissions();
  const templateId = watch('templateId');
  const isMultiMode = watch('isMultiMode');
  const canToggle =
    templateId > 0 &&
    !isMultiMode &&
    ((categoryName === 'Growth-Demand' &&
      emailTypeId === EMAIL_TYPE_IDS.OUTBOUND) ||
      (categoryName === 'Warmup Emails' &&
        emailTypeId === EMAIL_TYPE_IDS.MARKETING));

  useEffect(() => {
    if (!canToggle) {
      setValue('disable_click_tracking', false);
      setValue('disable_open_tracking', false);
    }
  }, [canToggle]);

  if (!canToggle || !userCheckPermission('mail.tracking.interrupt'))
    return <></>;

  return (
    <>
      <Controller
        control={control}
        name="disable_click_tracking"
        render={({ field: { value, onChange } }) => {
          return (
            <section className="send-mail-form__section">
              <div>
                <Checkbox
                  checked={value}
                  onChange={({ target: { checked } }) => {
                    onChange(checked);
                  }}
                >
                  Disable Click Tracking
                </Checkbox>
              </div>
            </section>
          );
        }}
      />
      <Controller
        control={control}
        name="disable_open_tracking"
        render={({ field: { value, onChange } }) => {
          return (
            <section className="send-mail-form__section">
              <div>
                <Checkbox
                  checked={value}
                  onChange={({ target: { checked } }) => {
                    onChange(checked);
                  }}
                >
                  Disable Open Tracking
                </Checkbox>
              </div>
            </section>
          );
        }}
      />
    </>
  );
};

export default ToggleDisableTracking;
